


































import {
  Component,
  Emit,
  Model,
  Prop,
  Vue,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, Mutation } from "vuex-class";
import SectionWrappe from "@/components/section/SectionWrappe.vue";
import Button from "@/components/button/Button.vue";
import * as types from "@/store/constants/types";
import Http from "@/api/http/fetch/index";
import * as AppLifeCycle from "@/utils/appLifeCycle";
import { getAppVersion, isIos } from "@/utils/lodash";
import { judgeVersion } from "@/utils/judgeVersion";

@Component({
  components: {
    SectionWrappe,
    Button
  }
})
export default class HotApp extends Vue {
  @Getter(types.GETTER_UNINSTALLED_APP) private uninstalledApp: any;
  @Getter(types.GETTER_SETTING_DATA) private settingData: any;
  @Action(types.ROUTER_PUSH) private routerPush: any;
  @Action(types.CHECK_GX_USER_LOGINED) private checkSignGxUser: any;
  @Action(types.SELECT_APP_STATE) private selectAppState: any;
  @Action(types.UPDATE_INTERFACE_EXIST_STATE)
  private updateInterFaceExistState: any;

  private listenKeyStr: string = "hotApps";

  get hotAppSettingEnable() {
    if (
      this.settingData &&
      this.settingData.enable &&
      this.settingData.enable.hasOwnProperty("hot_app_enabled")
    ) {
      return this.settingData.enable.hot_app_enabled;
    } else {
      return false;
    }
  }

  get hotAppShow() {
    return (
      this.uninstalledList &&
      this.uninstalledList.length > 0 &&
      this.hotAppSettingEnable
    );
  }

  get uninstalledList() {
    console.log("uninstalledApp result", this.uninstalledApp);
    return this.uninstalledApp;
  }

  private async clickItem(item: any) {
    const newItem =
      !isIos() && judgeVersion(getAppVersion(), "4.9.0")
        ? {
            ...item,
            isSuperPay: false,
            isPure: false
          }
        : item;
    console.log("clickItem:", newItem);

    //先check：
    const checkSignGxUserResult = await this.checkSignGxUser();
    if (checkSignGxUserResult) {
      Http.ADStart(newItem).then((result: any) => {
        console.log("ADStart result:", result);
      });
    }
  }

  private recommend() {
    this.selectAppState();
  }

  private beforeDestroy() {
    AppLifeCycle.removeListener(this.listenKeyStr);
  }

  private mounted() {
    //先ADConnect
    Http.ADConnect();
    this.updateInterFaceExistState();
    //然后获取推荐的列表
    this.recommend();
    // AppLifeCycle.addListener({
    //   key: this.listenKeyStr,
    //   fn: async () => {
    //     this.recommend();
    //   }
    // });
  }
}
